var map = {
	"./integrations.svg": "6f36",
	"./integrations/logo-small.svg": "7fd1",
	"./logo-small.svg": "5b7d",
	"./logo.svg": "5b1c",
	"./no-data.svg": "ca24",
	"./nodata.svg": "dec7",
	"./nodocs.svg": "9b18",
	"./user-management.svg": "0478"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";